import { useEffect } from 'react';

import { useGlobalStore } from '@/shared/stores/global.store';

export function useDirtyForm(isDirty: boolean) {
  const setDirty = useGlobalStore((state) => state.navigation.setDirty);

  useEffect(() => {
    setDirty(isDirty);
    return () => setDirty(false);
  }, [isDirty, setDirty]);
}
